function initializeSlickCarousel() {
  const bodyClasses = document.body.classList;

  if (
    (bodyClasses.contains("index") ||
      bodyClasses.contains("product") ||
      bodyClasses.contains("our-story") ||
      bodyClasses.contains("our-science") ||
      bodyClasses.contains("clinical-study") ||
      bodyClasses.contains("our-sustainability") ||
      bodyClasses.contains("account") ||
      bodyClasses.contains("order") ||
      bodyClasses.contains("page") ||
      bodyClasses.contains("cart")) &&
    $(window).width() <= 992 && $(".pdp-featured-collection .slider").length > 0
  ) {
    $(".pdp-featured-collection .slider").slick({
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      centerMode: false,
      accessibility: false,
    });
  }

  if (
    bodyClasses.contains("product") ||
    bodyClasses.contains("retargeting-users")
  ) {
    $(".product-carousel .carousel-container").slick({
      infinite: false,
      slidesToShow: 4.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,

      prevArrow:
        '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.2,
            centerMode: false,
          },
        },
      ],
    });
  }

  // Cart upsell section
  if (!bodyClasses.contains("product")) {
    $(".upsell-carousel").slick({
      infinite: false,
      arrows: true,
      dots: false,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: false,
      customPaging: function (slider, index) {
        return (
          '<button type="button" class="slick-dot">' + (index + 1) + "</button>"
        );
      },
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
    });
  }

  //Our story
  if (bodyClasses.contains("our-story")) {
    $(".image-carousel-container").slick({
      infinite: false,
      slidesToShow: 2.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      centerMode: false,
      accessibility: false,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 1.8,
          },
        },

        {
          breakpoint: 452,
          settings: {
            slidesToShow: 1.2,
          },
        },
      ],
    });
  }

  //Blog Ingredients
  if ($(window).width() <= 992 && bodyClasses.contains("article")) {
    $(".ingredients-parent").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: true,
      centerPadding: "10px",
      infinite: false,
      arrows: true,
      accessibility: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  //Collections
  if (bodyClasses.contains("collection")) {
    $(".customer-reviews-container").slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      customPaging: function (slider, index) {
        return (
          '<button type="button" class="slick-dot">' + (index + 1) + "</button>"
        );
      },
      prevArrow:
        '<button type="button" class="slick-prev svg-btn"><svg class="arr-svg" width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next svg-btn"><svg class="arr-svg" width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',

      responsive: [
        {
          breakpoint: 991, // Breakpoint at 1200px
          settings: {
            slidesToShow: 1, // Show 1 slide instead of 2
          },
        },
        {
          breakpoint: 601, // Breakpoint at 1200px
          settings: {
            slidesToShow: 1.1, // Show 1 slide instead of 2
          },
        },
      ],
    });
  }

  //App Timeline
  if (
    bodyClasses.contains("app") ||
    bodyClasses.contains("sleepRecoverySupplement") ||
    bodyClasses.contains("sleepRecoverySupplementV2") ||
    bodyClasses.contains("daySupplement") ||
    bodyClasses.contains("sleepRecoveryScalpElixirS2")
  ) {
    $(".timeline-mobile .slider").slick({
      infinite: false,
      arrows: false,
      dots: false,
      autoplay: false,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      accessibility: false,
    });

    $(".timeline-mobile .slider").on(
      "afterChange",
      function (event, slick, currentSlide) {
        $(".timeline-mobile .item-mobile-timeline").removeClass("active");
        $(".timeline-mobile .item-mobile-timeline")
          .eq(currentSlide)
          .addClass("active");

        // Toggle image display based on active state
        toggleImage(currentSlide);
      }
    );

    $(".item-mobile-timeline").click(function () {
      let index = $(this).index();
      $(".timeline-mobile .slider").slick("slickGoTo", index);
    });

    $(".timeline-mobile .slider").slick("slickGoTo", 0);
  }

  if (
    bodyClasses.contains("telehealth") ||
    bodyClasses.contains("bundleKits")
  ) {
    $(".telehealth-reviews-socials").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: false,
      centerMode: false,
      accessibility: false,
    });
  }

  if (
    (bodyClasses.contains("index") || bodyClasses.contains("product")) &&
    $(window).width() <= 992 && $(".ugc-video").length > 0
  ) {
    $(".ugc-video").slick({
      infinite: false,
      slidesToShow: 2.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      centerMode: false,
      swipeToSlide: true,
      accessibility: false // Disable the problematic ADA functionality
    });
  }

  if ($(window).width() <= 991) {
    if (bodyClasses.contains("sleepRecoveryDeStress")) {
      $(".app-lighting-grid .image-grid-container").slick({
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        centerMode: false,
        accessibility: false,
        customPaging: function (slider, index) {
          return (
            '<button type="button" class="slick-dot">' +
            (index + 1) +
            "</button>"
          );
        },
        prevArrow:
          '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2.5,
              centerMode: false,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1.2,
              centerMode: false,
            },
          },
        ],
      });
    }
  }

  if ($(window).width() <= 991 && bodyClasses.contains("product")) {
    $(".skin-wellness .wellness-items").slick({
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      customPaging: function (slider, index) {
        return `<button type="button" class="slick-dot">${index + 1}</button>`;
      },
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.5,
            centerMode: false,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1.2,
            centerMode: false,
          },
        },
      ],
    });
  }

  if (
    bodyClasses.contains("yoga-master-class") ||
    bodyClasses.contains("master-class")
  ) {
    $(".review-with-ratings-container").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      dots: true,
      centerPadding: "10px",
      infinite: false,
      arrows: false,
      accessibility: false,
      customPaging: function (slider, i) {
        return '<div class="custom-dot"></div>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
          },
        },
      ],
    });
  }

  if ($(window).width() <= 992 && bodyClasses.contains("master-class")) {
    $(".master-class-host-details").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      centerPadding: "10px",
      infinite: false,
      arrows: false,
      accessibility: false,
      customPaging: function (slider, i) {
        return '<div class="custom-dot"></div>';
      },
    });
  }

  if (bodyClasses.contains("reviews")) {
    $(".doctor-quote-slider .doctor-quote-slider-wrapper").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      centerPadding: "10px",
      infinite: false,
      arrows: true,
      accessibility: false,
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ]
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (typeof initializeSlickCarousel === "function") {
    initializeSlickCarousel();
  }
});
